import { useState, useEffect } from 'react';
import { useNavigation } from '../context/NavigationContext';
import Messaging from './Messaging';
import WatiTemplates from './WatiTemplates';

// Messaging groups the abandoned-cart tool and the WhatsApp (WATI) template switches
// as sub-tabs, same pattern as BrandOps.jsx. The whole tab is admin-only (App.jsx).
const SUB_TABS = [
  { key: 'carts', label: 'Abandoned Carts', Component: Messaging },
  { key: 'wati',  label: 'WATI Templates',  Component: WatiTemplates },
];

export default function MessagingHub() {
  const { navData, setSubTab } = useNavigation();
  const [active, setActive] = useState(
    SUB_TABS.some(t => t.key === navData?.subTab) ? navData.subTab : SUB_TABS[0].key);

  // ⌘K deep link: navigate('messaging', { subTab }).
  useEffect(() => {
    if (navData?.subTab && SUB_TABS.some(t => t.key === navData.subTab)) setActive(navData.subTab);
  }, [navData]);

  useEffect(() => { setSubTab('messaging', active); }, [active, setSubTab]);
  const ActiveComponent = SUB_TABS.find(t => t.key === active)?.Component;

  return (
    <div>
      <div className="bg-white border-b border-gray-200 px-6 pt-3 flex items-center gap-1">
        {SUB_TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={`px-4 py-2 text-sm font-semibold rounded-t-md transition-colors ${
              active === t.key
                ? 'text-zoddle-green border-b-2 border-zoddle-green'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {ActiveComponent && <ActiveComponent />}
    </div>
  );
}
